'use client';
import { ReactNode, useState } from 'react';
import { QueryClientProvider, QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { DEFAULT_QUERIES_OPTIONS } from '@/constants/query-config';
import { ApiFetcherError } from '@/lib/api-fetcher';
import { firebaseAuth } from '@/lib/firebase/firebase-client';
import { signOut } from '@/lib/utils';

type QueryProvidersProps = {
  children: ReactNode;
};

export default function QueryProviders({ children }: QueryProvidersProps) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: DEFAULT_QUERIES_OPTIONS,
        },
        queryCache: new QueryCache({
          onError: (error) => handleUnauthorizedError(error),
        }),
        mutationCache: new MutationCache({
          onError: (error) => handleUnauthorizedError(error),
        }),
      })
  );

  const handleUnauthorizedError = async (error: unknown) => {
    if (!(error instanceof ApiFetcherError)) return;
    if (error.status !== 401) return;

    // * Check if it's login
    const user = firebaseAuth.currentUser;
    if (!user) return;

    queryClient.clear();
    signOut();
  };

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      {children}
    </QueryClientProvider>
  );
}
